import * as React from "react";
export var OverlayType;

(function (OverlayType) {
  OverlayType["cart"] = "cart";
  OverlayType["checkout"] = "checkout";
  OverlayType["login"] = "login";
  OverlayType["message"] = "message";
  OverlayType["info"] = "info";
  OverlayType["sideNav"] = "side-nav";
  OverlayType["password"] = "password";
  OverlayType["search"] = "search";
  OverlayType["mainMenuNav"] = "main-menu-nav";
  OverlayType["modal"] = "modal";
  OverlayType["register"] = "register";
  OverlayType["popupMessage"] = "popup-message";
  OverlayType["addReview"] = "add-review";
  OverlayType["shareProject"] = "share-project";
  OverlayType["removeWishlistItem"] = "remove-wishlist-item";
  OverlayType["contactUs"] = "contact-us";
  OverlayType["dimensionPopup"] = "dimension-popup";
  OverlayType["colorSamples"] = "color-samples";
  OverlayType["reviewItem"] = "review-item";
  OverlayType["customTrack"] = "custom-track";
})(OverlayType || (OverlayType = {}));

export var OverlayTheme;

(function (OverlayTheme) {
  OverlayTheme["left"] = "left";
  OverlayTheme["right"] = "right";
  OverlayTheme["modal"] = "modal";
})(OverlayTheme || (OverlayTheme = {}));

/* tslint:disable:no-empty */
export var OverlayContext = React.createContext({
  context: null,
  hide: function hide() {},
  // eslint-disable-line @typescript-eslint/no-empty-function
  show: function show() {},
  // eslint-disable-line @typescript-eslint/no-empty-function
  theme: null,
  type: null
});
/* tslint:enable:no-empty */

OverlayContext.displayName = "OverlayContext";